var search = {
	openClass: 'open',
	cacheDom: function () {
		this.siteNav = $('.sitenav')
		this.siteSearch = $('.site-search')
		this.siteNavToggler = $('.sitenav__toggle')
		this.globalNav = $('.global-navigation')
		this.toggler = $('[data-toggle-site-search]')
		this.overlay = $('.site-overlay')
		this.wrapper = $('[data-site-search]')
		this.content = this.wrapper.find("[data-site-search__content]");
		this.form = this.wrapper.find("[data-site-search__form]");
		this.input = this.wrapper.find('[data-site-search__input]')
	},
	bindEvents: function () {
		this.input.on('keyup', this.performSearch.bind(this))
		this.toggler.on('tap', this.toggleSearch.bind(this))
	},
	toggleSearch: function () {
		$('body').addClass('noscroll')
		if ($(window).width() < 1025) {
			this.siteNav.addClass('open')
			this.globalNav.addClass('sitenav-is-open')
			this.siteNavToggler.addClass('tcon-transform')
			this.input.focus()

			return
		}

		this.wrapper.toggleClass(this.openClass)
		this.overlay.addClass('hide').toggleClass(this.openClass)
		this.toggler.toggleClass(this.openClass)

		// Focus on or clear input
		if (this.wrapper.hasClass(this.openClass)) {
			this.input.focus()
			this.overlay.one('click', this.toggleSearch.bind(this))
		} else {
			this.input.val('')
		}
	},
	performSearch: function () {
		//TODO: Throttle searches
		var loadUrl = this.form.attr("action") + "?" + this.form.serialize() + " .main > *:nth-child(n+1)";
		var siteSearch = this.siteSearch
		var content = this.content;

		siteSearch.addClass('loading')

		var data = $("<div>").load(loadUrl, function () {
			$(this).find("h1").remove();
			content.html($(this).html());
			siteSearch.removeClass("loading");
		});
		
	},
	init: function () {
		this.cacheDom()
		this.bindEvents()
	}
}

$(document).ready(function() {
	search.init()
});